<template>
  <div>
    <mapa-brasil v-if="mapaBrasil" />
    <div v-else id="mapa-area-atuacao" />
  </div>
</template>

<script>
  import L from 'leaflet';
  import 'leaflet/dist/leaflet.css';
  import MapboxConfig from '@/config/MapboxConfig';
  import mapbox from '@/config/Mapbox';
  import DadosAreaConcessaoService from '@/services/DadosAreaConcessaoService.js';

  const mapboxConfig = new MapboxConfig(mapbox.access_token, mapbox.style);

  export default {
    components: {
      MapaBrasil: () => import('@/components/general/graficos/MapaBrasil.vue')
    },
    data() {
      return {
        map: null,
        arat: {},
        mapaBrasil: false
      };
    },
    mounted() {
      this.configuraMapa(3);
      this.map.setView([-16.6974198, -49.2334694]);
      this.getArat();
    },
    methods: {
      configuraMapa(zoom) {
        this.map = L.map('mapa-area-atuacao', {
          layers: [mapboxConfig.getDefaultLayer()],
          zoom
        });
        L.control.layers(mapboxConfig.getBaseLayers()).addTo(this.map);
      },
      getArat() {
        DadosAreaConcessaoService.getDados().then(({ data }) => {
          if (!(data && data.data && data.data.dados_area_concessao)) {
            this.mapaBrasil = true;
            return;
          }
          this.arat = JSON.parse(data.data.dados_area_concessao);
        });
      },
      adicionaAratMapa() {
        const { geojson } = this.arat;
        if (!geojson) {
          this.mapaBrasil = true;
          return;
        }
        const layer = L.geoJSON(JSON.parse(geojson), {
          style: function () {
            return {
              color: '#f66448',
              weight: 1
            };
          }
        });
        layer.addTo(this.map);
        this.map.fitBounds(layer.getBounds());
      }
    },
    watch: {
      arat() {
        this.adicionaAratMapa();
      }
    }
  };
</script>

<style scoped>
  #mapa-area-atuacao {
    min-height: 237px;
    max-height: 237px;
    z-index: 0;
  }
</style>
